<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-8">
                <h1 class="m-0 text-dark">State Wise FSW Status</h1>
            </div>
  
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </section>
  <section class="content">
    <!-- Default box -->
    <div class="container-fluid">
  
        <div class="card">
  
            <div class="card-body">
      
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <td style="font-weight:bold">Sr. No.</td>
                            <!-- <td style="font-weight:bold">State Name</td> -->
                            <td style="font-weight:bold">State/UT</td>
                            <!-- <td style="font-weight:bold">FSW Allocated</td> -->
                            <td style="font-weight:bold">FSW Sanctioned</td>
                            <!-- <td style="font-weight:bold">FSW Running</td> -->
                            <td style="font-weight:bold">FSW Delivered</td>
                            <td style="font-weight:bold">FSW Registered</td>
                            <td style="font-weight:bold">Testing</td>
                            <td style="font-weight:bold">Awareness Programs</td>
                            <td style="font-weight:bold">Training</td>
                            <!-- <td style="font-weight:bold">Awareness Programs</td> -->
                            <td style="font-weight:bold" *ngIf="role!='IT-TEAM'">Action</td>
                        </tr>
                    </thead>
  
                    <tbody>
                        <tr
                            *ngFor="let item of data | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                            <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                            <td>{{ item.stateName }}</td>
                            <td>{{item.fswAllotted}}</td>
                            <td>{{item.fswRunning}}</td>
                            
                            <!-- <td><a href="./list-vehicle/{{item.stateCode}}">{{item.vehicles}}</a></td>
                            <td><a href="./list-testing/{{item.stateCode}}">{{item.testing}}</a></td>
                            <td><a href="./list-training/{{item.stateCode}}">{{item.training}}</a></td>
                            <td><a href="./list-awp/{{item.stateCode}}">{{item.awareness}}</a></td> -->

                            <td><a [routerLink]="['/list-vehicle/',item.stateCode]">{{item.vehicles}}</a></td>
                            <td><a [routerLink]="['/list-testing/',item.stateCode]">{{item.testing}}</a></td>
                            <td><a [routerLink]="['/list-awp/',item.stateCode]">{{item.awareness}}</a></td>
                            <td><a [routerLink]="['/list-training/',item.stateCode]">{{item.training}}</a></td>
                            <!-- <td><a [routerLink]="['/list-awp/',item.stateCode]">{{item.awareness}}</a></td> -->
                            <td *ngIf="role!='IT-TEAM'">
                                <input type="button" (click)="updateStatus(item.stateCode)"  value="Edit"
                                  class="btn btn-primary">
                              </td>
                          </tr>
                    </tbody>
                </table>
                <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls>
            </div>
        </div>
    </div>
  </section>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>